import IconButton from '@mui/material/IconButton';
import GetAppIcon from '@mui/icons-material/GetApp';
import CopyToClipboardButton from './Buttons/CopyToClipboardButton';
import { downloadData } from '../ui_utils';

/**
 * Text an action returned for the user to keep (an export), in a box that scrolls when it is long,
 * with the download and copy icon buttons the Export pane has.
 *
 * @param {{ file: { name: string, text: string } }} props
 */
export default function ReturnedText({ file }) {
    return (
        <div>
            <pre style={{
                maxHeight: '10em', overflow: 'auto', margin: 0, padding: '.3rem', background: 'white',
            }}
            >
                {file.text}
            </pre>
            <IconButton
                size="small"
                aria-label={`Download ${file.name}`}
                onClick={() => downloadData(file.name, file.text)}
            >
                <GetAppIcon fontSize="small" />
            </IconButton>
            <CopyToClipboardButton
                copyTarget={file.text}
                IconButtonProps={{ size: 'small', 'aria-label': `Copy ${file.name}` }}
            />
        </div>
    );
}
